module.exports = __webpack_public_path__ + "img/A_4ABSD-48_1.e33a1997.png";